import React from "react";
import values from "lodash/values";
import pick from "lodash/pickBy";
import { RaisedButton } from "material-ui";
import { Table, Tr, Td, Sort } from "reactable";

import EventTable from "./partials/event-table.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventActions from "../actions/EventActions";
import EventStore from "../stores/EventStore";

import config from "../config";
import UserStore from "../stores/UserStore";

import WorkingIndicator from "./partials/working-indicator.jsx";

class Events extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showScanCounts: false,
      isReadOnly:
        UserStore.hasPermission("view_event") &&
        !UserStore.hasPermission("edit_event")
    };

    this._onShowScanCountsCheck = this._onShowScanCountsCheck.bind(this);
    this._onRefresh = this._onRefresh.bind(this);
  }

  static getStores() {
    return [EventStore];
  }

  static getPropsFromStores() {
    return EventStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {};
  }

  _onShowScanCountsCheck(checked) {
    this.setState({
      showScanCounts: checked
    });

    if (checked) {
      EventActions.fetchAllForBucket(
        this.props.params.eventBucketId,
        /* includeScanCounts */ true
      );
    }
  }

  _onRefresh() {
    EventActions.fetchAllForBucket(
      this.props.params.eventBucketId,
      this.state.showScanCounts
    );
  }

  downloadCsv() {
    window.open(
      `${config.endpoint}event_buckets/${this.props.params.eventBucketId
      }/events.csv?${UserStore.makeApiKeyQueryString()}`,
      "_blank"
    );
  }

  componentWillMount() {
    EventActions.fetchAllForBucket(this.props.params.eventBucketId);
  }

  render() {
    let styles = this.getStyles(),
      bucket = this.props.params.eventBucketId,
      events = values(
        pick(this.props.events, e => {
          return e.event_bucket === bucket && !e.is_virtual;
        })
      );

    if (events.length === 0 && EventStore.getState().isFetching) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h1 class="page-title">Physical Events</h1>
        <EventTable
          eventBucket={bucket}
          events={events}
          onShowScanCountsCheck={this._onShowScanCountsCheck}
          onRefresh={this._onRefresh}
          isRefreshing={this.props.isFetching}
          createButton={
            <span>
              {UserStore.hasPermission("edit_physical_event") ? (
                <RaisedButton
                  label="Create new event"
                  primary={true}
                  onTouchTap={() =>
                    this.context.router.push(
                      `/event_buckets/${this.props.params.eventBucketId}/events/new`
                    )
                  }
                />
              ) : null}
              {UserStore.hasPermission("bulk_import") ? (
                <RaisedButton
                  style={{ marginLeft: 7 }}
                  onTouchTap={() =>
                    this.context.router.push(
                      `/event_buckets/${this.props.params.eventBucketId}/bulk_import_events`
                    )
                  }
                  label="Bulk import"
                />
              ) : null}
              <RaisedButton
                style={{
                  marginLeft: UserStore.hasPermission("edit_physical_event")
                    ? 7
                    : 0
                }}
                onTouchTap={() => this.downloadCsv()}
                label="Download all (.csv)"
              />
            </span>
          }
        />
      </div>
    );
  }
}

export default connectToStores(Events);



// WEBPACK FOOTER //
// ./src/app/components/events.jsx